import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { first } from 'rxjs/operators';
import { RestorePasswordModel } from '../../../model/restorepasswordmodel';
import { RestorePasswordService } from '../../../service/restore-password.service';

@Component({
  selector: 'app-email-phase',
  templateUrl: './email-phase.component.html',
  styleUrls: ['./email-phase.component.css']
})
export class EmailPhaseComponent implements OnInit {

    email: string;
    isValidRequest = true;
    @Input() restorePwdModel: RestorePasswordModel;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onSuccess = new EventEmitter<RestorePasswordModel>();

    constructor(private restorePwdSrv: RestorePasswordService) { }

    ngOnInit() {
    }

    next() {
        if (!this.validateRequest()) {
            return;
        }

        this.restorePwdModel = new RestorePasswordModel();
        this.restorePwdModel.email = this.email;
        this.restorePwdSrv.code(this.restorePwdModel)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.outcome === 'OK') {
                        this.onSuccess.emit(this.restorePwdModel);
                    }
                },
                error => {
                    return;
                }
            );
    }

    private validateRequest(): boolean {
        let isValid = true;
        if (this.email == null || this.email === '') {
            this.isValidRequest = false;
            isValid = false;
        }
        return isValid;
    }

}
